import Vue from 'vue'
import Router from 'vue-router'
import pdfPreview from '@/components/pdf-preview'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'pdfPreview',
      component: pdfPreview
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js